module.exports = __webpack_public_path__ + "static/img/bg.9c0421d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/feature6/bg.jpg
// module id = l5/t
// module chunks = 7